module.exports = __webpack_public_path__ + "5a1f5821b19bb252273ae486546d313f.pdf";